const LOCAL_STORAGE_USER_TOKEN_KEY = 'AUTH_USER_TOKEN'
const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'AUTH_REFRESH_TOKEN'

export const setLocalStorageUserToken = (token: string) => {
  localStorage.setItem(LOCAL_STORAGE_USER_TOKEN_KEY, token)
}

export const removeLocalStorageUserToken = () => {
  localStorage.removeItem(LOCAL_STORAGE_USER_TOKEN_KEY)
}

export const getLocalStorageUserToken = () => {
  return localStorage.getItem(LOCAL_STORAGE_USER_TOKEN_KEY)
}

export const setLocalStorageRefreshToken = (token: string) => {
  localStorage.setItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY, token)
}

export const removeLocalStorageRefreshToken = () => {
  localStorage.removeItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY)
}

export const getLocalStorageRefreshToken = () => {
  return localStorage.getItem(LOCAL_STORAGE_REFRESH_TOKEN_KEY)
}
